import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('Verifying your email...');
    const { verifyEmail } = useAuth();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Missing verification token.');
            return;
        }

        const doVerify = async () => {
            try {
                await verifyEmail(token);
                setStatus('success');
                setMessage('Email verified successfully! Logging you in...');
                // Redirection will be handled by PublicLayout once checkAuth completes
            } catch (error) {
                setStatus('error');
                setMessage(error.response?.data?.detail || 'Verification failed. The link may be expired.');
            }
        };

        doVerify();
    }, [token, verifyEmail, navigate]);

    return (
        <div className="flex justify-center items-center min-h-[60vh]">
            <div className="bg-bg-panel p-12 rounded-lg text-center max-w-md border border-border-light shadow-xl">
                <h2 className={`text-2xl font-bold mb-4 ${status === 'error' ? 'text-accent-red' : status === 'success' ? 'text-green-400' : 'text-white'}`}>
                    {status === 'verifying' ? 'Verifying...' : status === 'success' ? 'Success!' : 'Error'}
                </h2>
                <p className="text-text-muted mb-8">{message}</p>
                {status !== 'verifying' && (
                    <button
                        onClick={() => navigate('/')}
                        className="px-6 py-2 bg-accent-blue text-white rounded font-semibold hover:bg-blue-600 transition-colors"
                    >
                        Go to Login
                    </button>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;
